import { Component, Input, OnDestroy } from '@angular/core';
import { Mime } from '@shared/api/common/mime-type';

@Component({
  selector: 'app-media-recorder',
  templateUrl: './media-recorder.component.html',
  styleUrl: './media-recorder.component.scss',
  standalone: false
})
export class MediaRecorderComponent implements OnDestroy {
  @Input() mimeType: Mime.AudioWebm | Mime.VideoWebm | `${Mime.AudioWebm | Mime.VideoWebm}` = Mime.VideoWebm;
  public recorder: MediaRecorder | undefined;

  ngOnDestroy(): void {
    this.recorder?.stop();
  }

  public startRecording(stream: MediaStream) {
    this.recorder = new MediaRecorder(stream);
    this.recorder.start();
  }

  public stopRecording(): Promise<Blob> {
    return new Promise((resolve, reject) => {
      if (!this.recorder) {
        return reject("No recording was started");
      }

      this.recorder.ondataavailable = (event) => {
        resolve(this.toFile(event.data))
      }
      this.recorder.onerror = reject;
      this.recorder.stop()
    });
  }

  private toFile(data: Blob) {
    return new Blob([data], { 'type' : this.mimeType });
  }
}
